import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function TrashIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'TextSubtleGrey', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M5.135 20.159a2.277 2.277 0 002.27 2.27h9.08a2.277 2.277 0 002.269-2.27V6.539H5.134v13.62zM19.889 3.135h-3.972L14.782 2H9.107L7.972 3.135H4v2.27h15.889v-2.27z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=Trash.js.map